import React from 'react';

const Tag = ({ id, title, data, color }) => {
  return (
    <>
      <div className={`tag-${id}`}>{data ? data + ' ' + title : title}</div>
      <style jsx>{`
        .tag-${id} {
          border-radius: 4px;
          background-color: ${color};
          padding: 3px 10px;
          color: #242424;
          font-size: 15px;
          font-weight: 600;
          font-family: 'Roboto-Medium';
          text-align: center;
        }
        @media (max-width: 375px) {
          .tag-${id} {
            font-size: 11px;
            font-weight: bold;
            align-items: center;
            padding: 5px 12px;
          }
        }
        @media (max-width: 321px) {
          .tag-${id} {
            font-size: 10px;
            align-items: center;
            padding: 3px 7px;
          }
        }
      `}</style>
    </>
  );
};

export default Tag;
